module.exports = __webpack_public_path__ + "img/shenFenZheng.4927d379.png";